export default "__VITE_ASSET__qshkRZ0DEmujvDHMfSVlug__"